"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _useUpsell = _interopRequireDefault(require("../../hooks/upsell/useUpsell"));
var _r10SourceLibrary = require("r10-source-library");
var _services = require("../../services");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _UpsellCardFactory = _interopRequireDefault(require("./UpsellCardFactory"));
var _BaseComponents = require("../StyledComponents/BaseComponents");
var _widgetSelectors = require("../../store/widget/widgetSelectors");
var _useAppSelector = require("../../hooks/useAppSelector");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const CardContainer = _styledComponents.default.div`
  display: flex;
  overflow: hidden;
`;
const CardContainerTest = _styledComponents.default.div`
  display: flex !important;
  flex-direction: column;
  height: 100%;
`;
const LightContainer = (0, _styledComponents.default)((0, _BaseComponents.LightBackground)('div'))`
  padding: 20px 30px;
  margin-bottom: 20px;
  @media (max-width: ${_r10SourceLibrary.themeWS10.breakpoints.md}px) {
    padding: 2px 5px;
  }
`;
const UpsellCategoryDisplay = () => {
  const {
    relationshipOfferingGroups,
    onUpsellProductAdd,
    onUpsellProductRemove,
    isDisabled
  } = (0, _useUpsell.default)();
  const {
    showModalView
  } = (0, _useAppSelector.useAppSelector)(_widgetSelectors.selectUiSettings);
  const Wrapper = showModalView ? _react.Fragment : LightContainer;
  const smallScreen = (0, _useMediaQuery.default)('(min-width:600px)');
  const breakpoints = (0, _r10SourceLibrary.useBreakpoints)();
  const smallScreenSize = breakpoints.sm && smallScreen || window.innerWidth == _r10SourceLibrary.themeWS10.breakpoints.md;
  return /*#__PURE__*/_react.default.createElement(Wrapper, null, relationshipOfferingGroups.map((group, index) => {
    return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        top: 3,
        bottom: 5
      },
      key: index
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
      level: 4,
      weight: 3
    }, _services.locale.localeString(`RelationshipOffer.${group.groupName}`)), /*#__PURE__*/_react.default.createElement(CardContainer, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.CardCarousel, {
      allowOverflow: true,
      slidesToShow: {
        xl: 2,
        md: 2,
        sm: smallScreenSize ? 2 : 1
      },
      slidesToScroll: {
        xl: 1
      },
      id: `${group.groupName}-carousel`
    }, group.products.map((mainUpsellOffering, index) => {
      var _group$selectedProduc;
      const isSelected = (_group$selectedProduc = group.selectedProducts) === null || _group$selectedProduc === void 0 ? void 0 : _group$selectedProduc.includes(mainUpsellOffering.id);
      return /*#__PURE__*/_react.default.createElement(CardContainerTest, {
        key: mainUpsellOffering.id
      }, /*#__PURE__*/_react.default.createElement(_UpsellCardFactory.default, {
        product: mainUpsellOffering,
        index: index,
        onAddToCart: onUpsellProductAdd,
        onRemoveFromCart: onUpsellProductRemove,
        isDisabled: isDisabled(group.groupName, mainUpsellOffering.id),
        isSelected: isSelected
      }));
    }))));
  }));
};
var _default = UpsellCategoryDisplay;
exports.default = _default;